export default {
  title: {
    id: 'product_faq_modal_title',
    defaultMessage: 'Frequently asked questions',
  },
  errorTitle: {
    id: 'product_modal_api_error_title',
    defaultMessage: 'There seems to be a hitch!',
  },
  errorSubTitle: {
    id: 'product_modal_api_error_subtitle',
    defaultMessage: 'Refresh the page or try again later.',
  },
}
